module.exports = __webpack_public_path__ + "static/media/warning.46d2d44b.jpg";